import { usePage } from '@inertiajs/react';
import type { HackerSelfFinanceFlightsShow } from '@/types';
import { SelfFinanceFlightForm } from './components/SelfFinanceFlightForm';
import { SelfFinanceResponseReceived } from './components/SelfFinanceResponseReceived';

// /hacker/:publicId/self-finance-flight. `deadline` is null exactly when the team has
// already answered, which is what the Next page branched on.
export default function Show({
  publicId,
  deadline,
  statusData,
  eventCopy,
}: HackerSelfFinanceFlightsShow) {
  const errors = usePage().props.errors as unknown as Record<
    string,
    string | undefined
  >;

  return (
    <div className="min-h-screen bg-background">
      <div className="container relative mx-auto px-4 py-12 md:py-16">
        <div className="absolute top-4 right-4 z-20 sm:top-6 sm:right-6 md:top-8 md:right-8">
          <div
            className="aspect-[576/112] h-7 w-auto sm:h-9 md:h-10"
            style={{
              backgroundColor: 'hsl(var(--primary))',
              maskImage: 'url(/assets/logos/platanus.svg)',
              maskSize: 'contain',
              maskRepeat: 'no-repeat',
              maskPosition: 'center',
              WebkitMaskImage: 'url(/assets/logos/platanus.svg)',
              WebkitMaskSize: 'contain',
              WebkitMaskRepeat: 'no-repeat',
              WebkitMaskPosition: 'center',
            }}
          />
        </div>

        <div className="mx-auto w-full max-w-3xl">
          {deadline ? (
            <SelfFinanceFlightForm
              publicId={publicId}
              statusData={statusData}
              deadline={deadline}
              eventCopy={eventCopy}
              error={errors.base ?? null}
            />
          ) : (
            <SelfFinanceResponseReceived
              currentStatus={statusData.submission.status}
              modality={statusData.submission.modality}
              eventCopy={eventCopy}
            />
          )}
        </div>
      </div>
    </div>
  );
}
